import { ActivityHeaderSectionLayout } from 'modules/components/layer31';
import React, { ReactNode } from 'react';



export type ActivityHeaderSectionWithMetricsLayoutProps = {
  metrics: ReactNode;
  title?: string;
  actionButtons?: ReactNode | ReactNode[];
  subtitle?: string;
  backButton?: ReactNode;
  children?: ReactNode | ReactNode[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: ActivityHeaderSectionWithMetricsLayoutProps) => {

  return (
    <ActivityHeaderSectionLayout.FC
      title={props.title}
      subtitle={props.subtitle}
      actionButtons={props.actionButtons}
      backButton={props.backButton}
    >
      {/* METRIC Section */}
      {props.metrics}

    </ActivityHeaderSectionLayout.FC>
  );
};
